import TextField from '@mui/material/TextField'
import React from 'react'

import { SpacingContainer } from './common'

export type Props = {
  label?: string
  selectedAnswer: string
  onAnswerChange: (value: string) => void
}

const CatiAnswerOpenEnded: React.FC<Props> = ({ label, selectedAnswer, onAnswerChange }) => (
  <SpacingContainer spacing={2}>
    <TextField
      id="cati-open-ended-text-input"
      label={label ?? 'Response'}
      multiline
      rows={4}
      variant="outlined"
      fullWidth
      value={selectedAnswer}
      onChange={(e) => onAnswerChange(e.currentTarget.value)}
    />
  </SpacingContainer>
)

export default CatiAnswerOpenEnded
